import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
import { Message } from 'element-ui';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'EditVau',
  data: function data() {
    return {
      title: '',
      form: {
        pvTitle: null,
        pvStartTime: null,
        pvEndTime: null,
        pvAuth: null
      },
      rules: {
        pvTitle: [{
          required: true,
          message: '请输入标题内容',
          trigger: 'blur'
        }],
        pvStartTime: [{
          required: true,
          message: '请选择日期',
          trigger: 'blur'
        }],
        pvEndTime: [{
          required: true,
          message: '请选择日期',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.memberIds = data;
    },
    updateApi: function updateApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.form.pvStartTime = _this.form.pvStartTime + ' 00:00:00';
              _this.form.pvEndTime = _this.form.pvEndTime + ' 23:59:59';
              _this.form.pvAuth = 'yes';
              _context.n = 1;
              return api.UPDATE_MEMBER(_this.form);
            case 1:
              _this.$emit('initTableData', _this.form.birthday);
              _this.$message.success('操作成功');
              _this.handleClose();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    save: function save() {
      var _this2 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this2.form.memberIds !== null) {
            _this2.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this2.updateApi();
            }).catch(function () {
              _this2.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            Message.error('请选择会员');
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};